<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar
        </b-button>
        <licitacao-form
            operacaoProp="I"
            :convenio="convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></licitacao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import LicitacaoForm from './LicitacaoForm'

export default {
    components: {
        LicitacaoForm
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(licitacao){
            this.$store.dispatch('addRequest')
            ConveniosServicos.inserirLicitacao(licitacao)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Licitação inserida com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        }
    }
}
</script>
